(function () {
    'use strict';

    angular
        .module('elogbooksFilters')
        .filter('permissionLabel', permissionLabelFilter);

    permissionLabelFilter.$inject = ['$translate'];

    function permissionLabelFilter($translate) {
        return function (permission) {
            if (!permission) return '';

            var typeMap = [
                { prefix: 'site_permission_',        label: 'SITE_PERMISSION' },
                { prefix: 'operative_permission_',   label: 'OPERATIVE_PERMISSION' },
                { prefix: 'user_permission_report_', label: 'REPORT_PERMISSION' },
                { prefix: 'user_permission_',        label: 'USER_PERMISSION' }
            ];

            var typeLabel = '';

            for (var i = 0; i < typeMap.length; i++) {
                if (permission.indexOf(typeMap[i].prefix) === 0) {
                    typeLabel = typeMap[i].label;
                    break;
                }
            }

            var translated = $translate.instant(permission.toUpperCase());

            return typeLabel ? $translate.instant(typeLabel) + ' ' + translated : translated;
        };
    }
})();
